import PropTypes from 'prop-types';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';
import React from 'react';

class AppConfigForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedType: '',
      options: [],
      formData: {},
      apps: ['Core', 'Scorecard'],
    };
  }

  componentDidMount() {
    this.setState({
      options: this.props.types,
      selectedType: this.props.app_config.name || this.props.types[0],
      formData: this.getFormData(),
    });
  }

  getFormData = () => {
    if (this.props.app_config.id !== null) {
      return JSON.parse(this.props.app_config.config);
    }
    return {};
  };
  handleSelectChange = (event) => {
    this.setState({ selectedType: event.target.value });
  };

  onChange = ({ formData }, e) => {
    const el = document.getElementById('app_config_config');
    el.value = JSON.stringify(formData);
  };

  onSubmit = () => {
    document.querySelector('.form-submit').click();
  };

  render() {
    const selectedSchema = this.props.schema[this.state.selectedType] || {};
    return (
      <div id="appConfigForm">
        <div className="col-span-3 grid grid-cols-3 pb-6">
          <h3 className="pr-2 col-span-1 col-start-1 font-medium text-gray-700">
            {' '}
            Select a config type:
          </h3>
          <select
            className="col-span-1 col-start-2 md: mr-3 shadow-sm px-2 sm: border border-gray-300 rounded-md"
            id={'config_type_select'}
            onChange={this.handleSelectChange}
            defaultValue={this.state.selectedType}
          >
            {this.state.options.map((opt, index) => (
              <option key={index} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>

        <input
          type="hidden"
          name={`app_config[name]`}
          id={'configName'}
          value={this.state.selectedType}
        />
        <input
          type="hidden"
          name={`app_config[app]`}
          id={'configApp'}
          value={'Core'}
        />
        <Form
          schema={selectedSchema}
          onSubmit={this.onSubmit}
          onChange={this.onChange}
          formData={this.state.formData}
          validator={validator}
        >
          <React.Fragment />
        </Form>
      </div>
    );
  }
}

AppConfigForm.propTypes = {
  schema: PropTypes.object,
};

export default AppConfigForm;
